import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StringService {
  toHtmlEntities(str = ''): string {
    const tagsToReplace: Record<string, string> = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
    };

    const replaceTag = (tag: string) => tagsToReplace[tag] || tag;

    return str.replace(/[&<>]/g, replaceTag);
  }
}
